var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor reservation-select-day" }, [
    _c("div", { staticClass: "reservation-select-day-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.RESERVATION_SELECT_DAY"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: { "show-search": "" },
              model: {
                value: _vm.clone.reservationPlanId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "reservationPlanId", $$v)
                },
                expression: "clone.reservationPlanId",
              },
            },
            _vm._l(_vm.reservationPlans, function (reservationPlan, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: reservationPlan._id } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(reservationPlan.title) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "inputTitle mt-5 mb-2 font-weight-bold" }, [
      _vm._v(_vm._s(_vm.$t("chatbotv2.followingAttributesFilled"))),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "next-step-filled-items-wrapper" },
      _vm._l(_vm.nextStepFilledValue, function (attr) {
        return _c(
          "div",
          { key: attr, staticClass: "logos middle-section" },
          [
            _c("AttributeIconPreview", { attrs: { attribute: attr } }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ml-2" },
              [_c("AttributeLabel", { attrs: { attribute: attr } })],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }